import workflowTypes from './types';

const initialState = {
  workflows: [],
  fetchingWorkflows: false,
  errorFetchingWorkflows: null,
};

function workflowsReducer(state = initialState, { type, payload }) {
  switch (type) {
    case workflowTypes.FETCH_WORKFLOWS_REQUEST:
      return {
        ...state,
        fetchingWorkflows: true,
      };
    case workflowTypes.FETCH_WORKFLOWS_SUCCESS:
      return {
        ...state,
        workflows: payload,
        fetchingWorkflows: false,
      };
    case workflowTypes.FETCH_WORKFLOWS_FAILURE:
      return {
        ...state,
        fetchingWorkflows: false,
        errorFetchingWorkflows: payload,
      };
    default:
      return state;
  }
}

export default workflowsReducer;
